<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5 0.5V15.5H0.5V0.5H15.5Z" stroke="currentColor"/>
<path d="M2 0V16" stroke="currentColor" stroke-width="2"/>
</svg>
